module.exports = __webpack_public_path__ + "static/media/lnv500.c1055ee1.png";